import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Modal,
  Form,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";
import {
  applyProduct_InquiryDetails,
  getItemCategoryActiveList,
  getProductActiveListByCategoryID,
} from "../MeldiDhamCRUD";
import ElementPage from "../../Elements";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { addItem } from "../../../store/cartSlice";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

const CategoryListForHome = () => {
  const [products, setProducts] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const pathUrl = process.env.REACT_APP_API_URL;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    getCategoriesData();
  }, []);

  useEffect(() => {
    if (activeCategory) {
      getProductsData(activeCategory);
    }
  }, [activeCategory]);

  const getCategoriesData = async () => {
    try {
      const res = await getItemCategoryActiveList();
      if (res.data.isSuccess) {
        const activeCategories = res.data.responseObject;
        setCategoryData(activeCategories);

        // Set default first category
        // if (activeCategories.length > 0) {
        //   setActiveCategory(activeCategories[0].productCategoryID);
        // }
        getProductsData(0);
      }
    } catch (err) {
      console.error("Category fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const getProductsData = async (categoryId) => {
    setLoading(true);
    try {
      const res = await getProductActiveListByCategoryID(categoryId);
      if (res.data.isSuccess) {
        setProducts(res.data.responseObject);
        setActiveCategory(categoryId);
      }
    } catch (err) {
      console.error("Product fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCategory = (categoryId) => {
    setActiveCategory(categoryId);
    getProductsData(categoryId);
  };

  const getLocalized = (item, field) => {
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    if (lang === "en") return item[`${field}_EN`] || item[field];
    return item[field];
  };

  // ✅ Add this function
  const handleAddToCart = (prod) => {
    console.log("Adding to cart:", prod);
    dispatch(
      addItem({
        id: prod.productID,
        prodCatgryID: prod.productCategoryID,
        name: getLocalized(prod, "productName"),
        categoryName: getLocalized(prod, "productCategoryName"),
        price: prod.price,
        image: prod.photoPath,
        qty: 1,
      })
    );
    toast.success(`${getLocalized(prod, "productName")} added to cart!`);
  };

  // --------------------------------Inquiry --------------------------------
  const [showModal, setShowModal] = useState(false);
  const [productID, setProductID] = useState(0);
  const [productCategoryID, setProductCategoryID] = useState(0);
  const [productName, setProductName] = useState("");
  const [productCategoryName, setProductCategoryName] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const [formData, setFormData] = useState({
    productID: 0,
    productCategoryID: 0,
    name: "",
    email: "",
    contact: "",
    message: "",
    terms: false,
  });

  const handleCloseModal = () => {
    reset();
    setShowModal(false);
  };

  const handleOpenModal = (
    selProductID,
    selProductName,
    selProductCategoryID,
    selProductCategoryName
  ) => {
    setProductName(selProductName);
    setProductCategoryName(selProductCategoryName);
    setProductID(selProductID);
    setProductCategoryID(selProductCategoryID);

    setFormData((prev) => ({
      ...prev,
      productID: selProductID,
      productCategoryID: selProductCategoryID,
    }));
    setShowModal(true);
  };
  const onSubmit = async (data) => {
    try {
      const res = await applyProduct_InquiryDetails(
        data.name,
        "",
        data.contact,
        data.message,
        "192.168.0.1",
        data.terms,
        1,
        0,
        1,
        productID,
        productCategoryID
      );
      if (res.data.isSuccess) {
        alert(res.data.message || "Inquiry submitted successfully!");
        reset();
        setShowModal(false);
      } else {
        alert(res.data.message || "Failed to submit inquiry.");
      }
    } catch (error) {
      console.error("Error submitting inquiry:", error);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <>
      <Container className="py-4">
        {/* Category List */}
        <div
          className="d-flex overflow-auto pb-2"
          style={{
            scrollbarWidth: "thin",
            width: "100%",
            scrollbarColor: "#888 #f1f1f1",
          }}
        >
          <Card
            key={0}
            className={`shadow-sm border-1 flex-shrink-0 item-align-center me-2 ${
              activeCategory === 0 ? "border-success" : "border-light"
            }`}
            style={{ width: "200px", cursor: "pointer" }}
            onClick={() => handleCategory(0)}
          >
            <Card.Body className="text-center">
              {/* <Card.Title className="mb-0 fs-5"> */}
              {t("all")}
            </Card.Body>
          </Card>
          {categoryData.map((cat) => (
            <Card
              key={cat.productCategoryID}
              className={`shadow-sm border-1 text-center ${
                activeCategory === cat.productCategoryID
                  ? "border-success"
                  : "border-light"
              }`}
              style={{
                width: "180px",
                cursor: "pointer",
                flex: "0 0 auto",
                marginRight: "8px",
              }}
              onClick={() => handleCategory(cat.productCategoryID)}
            >
              <Card.Body
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px", // spacing between image and text
                  padding: "2px",
                }}
              >
                {cat.photoPath && (
                  <img
                    src={process.env.REACT_APP_API_URL + cat.photoPath}
                    alt={getLocalized(cat, "productCategoryName")}
                    style={{
                      width: "40px",
                      height: "40px",
                      objectFit: "contain",
                    }}
                  />
                )}

                <div className="fw-semibold">
                  {getLocalized(cat, "productCategoryName")}
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>

        {/* Product List */}
        {/* <h6 className="fw-bold mb-3 text-center color-orange-700">
          Product List
        </h6> */}
        <h5
          className="mb-3 d-block text-center fw-bold mt-4"
          style={{ fontSize: "1.7rem", color: "#31572C" }}
        >
          Product List
        </h5>
        {loading ? (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : products.length > 0 ? (
          <Row className="g-4">
            {products.map((prod) => (
              <Col key={prod.productID} xs={12} sm={6} md={3}>
                <Card className="h-100 shadow-sm px-3">
                  <Card.Img
                    variant="top"
                    src={pathUrl + prod.photoPath || "/images/no-image.png"}
                    alt={getLocalized(prod, "productName")}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>{getLocalized(prod, "productName")}</Card.Title>
                    {/* <p className="text-muted">₹ {prod.price}</p> */}
                    <div className="mt-auto d-flex justify-content-between">
                      {/* <Button
                        variant="danger"
                        style={{ backgroundColor: "#31572C", color: "white" }}
                        size="sm"
                        onClick={() => handleAddToCart(prod)} // ✅ dispatch here
                      >
                        <i className="bi bi-cart-plus me-1"></i>
                        Add To Cart
                      </Button> */}
                      <Button
                        style={{ backgroundColor: "#31572C", border: "none" }}
                        size="sm"
                        className="mt-2 fw-bold"
                      >
                        <Link
                          to={`/product/${prod.productID}`}
                          // style={{ backgroundColor: "#31572C", color: "white" }}
                          // className="btn btn-sm btn-outline-success fw-bold"
                        >
                          {" "}
                          <i className="fas fa-eye px-1"></i>
                          View
                        </Link>
                      </Button>
                      <Button
                        style={{
                          backgroundColor: "#31572C",
                          border: "none",
                          color: "white",
                        }}
                        size="sm"
                        className="mt-2 fw-bold"
                        onClick={() =>
                          handleOpenModal(
                            prod.productID,
                            prod.productName,
                            prod.productCategoryID,
                            prod.productCategoryName
                          )
                        }
                      >
                        Inquiry Now
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <div
            className="col-12 d-flex flex-column justify-content-center align-items-center text-center"
            style={{ minHeight: "80px" }}
          >
            <p className="fs-6 text-muted">{t("no_data")}</p>
            <img
              src="/assets/logo/15-dark.png"
              alt={t("no_data")}
              // height={25}
              width={55}
            />
          </div>
        )}
      </Container>

      {/* ✅ Inquiry Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title className="text-yellow-500">
              Product Inquiry
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Select
                    value={formData.productCategoryID}
                    onChange={(e) => {
                      const selectedCatId = Number(e.target.value);
                      setFormData((prev) => ({
                        ...prev,
                        productCategoryID: selectedCatId,
                        productID: 0,
                      }));

                      getProductsData(selectedCatId);
                    }}
                    required
                  >
                    <option value={0}>-- Select Product Category --</option>
                    {categoryData.map((cate) => (
                      <option
                        key={cate.productCategoryID}
                        value={cate.productCategoryID}
                        onChange={() => getProductsData(cate.productCategoryID)}
                      >
                        {getLocalized(cate, "productCategoryName")}
                        {/* {cate.productCategoryName}&nbsp;{" "}
                        {cate.productCategoryName_GJ} &nbsp;
                        {cate.productCategoryName_HN} */}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Select
                    value={formData.productID}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        productID: Number(e.target.value),
                      }))
                    }
                    required
                  >
                    <option value={0}>-- Select Product --</option>
                    {products.map((prod) => (
                      <option key={prod.productID} value={prod.productID}>
                        {/* {prod.productName}&nbsp; {prod.productName_GJ} &nbsp;
                        {prod.productName_HN} */}

                        {getLocalized(prod, "productName")}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    {...register("name", { required: "Name is required" })}
                    placeholder="Enter your name"
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </Form.Group>

                {/* <Form.Group className="mb-3">
                  <Form.Control
                    type="email"
                    {...register("email")}
                    placeholder="Enter your email"
                  />
                </Form.Group> */}

                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Mobile number"
                    maxLength={10}
                    {...register("contact", {
                      required: "Mobile number is required",
                      minLength: { value: 10, message: "Must be 10 digits" },
                      maxLength: { value: 10, message: "Must be 10 digits" },
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Only numbers allowed",
                      },
                    })}
                    onInput={(e) => {
                      const value = e.target.value;
                      // If user typed any non-numeric character
                      if (/[^0-9]/.test(value)) {
                        toast.error("Only numbers are allowed");
                        e.target.value = value.replace(/[^0-9]/g, ""); // remove alphabets
                      }
                    }}
                  />
                  {errors.contact && (
                    <small className="text-danger">
                      {errors.contact.message}
                    </small>
                  )}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3 h-100">
                  <Form.Control
                    as="textarea"
                    rows={8}
                    {...register("message", {
                      required: "Message is required",
                    })}
                    placeholder="Enter your message"
                  />
                  {errors.message && (
                    <small className="text-danger">
                      {errors.message.message}
                    </small>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Check
                  type="checkbox"
                  label="I agree to the terms and conditions"
                  {...register("terms", {
                    required: "You must accept the terms",
                  })}
                />
                {errors.terms && (
                  <small className="text-danger">{errors.terms.message}</small>
                )}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              style={{ backgroundColor: "#31572C", border: "none" }}
            >
              Submit
            </Button>
            <Button variant="danger" onClick={handleCloseModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* <ElementPage /> */}
    </>
  );
};

export default CategoryListForHome;
